import { render, staticRenderFns } from "./ShowSubmissionDetailsModal.vue?vue&type=template&id=3f56f84a&scoped=true&lang=pug"
import script from "./ShowSubmissionDetailsModal.vue?vue&type=script&lang=js"
export * from "./ShowSubmissionDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./ShowSubmissionDetailsModal.vue?vue&type=style&index=0&id=3f56f84a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f56f84a",
  null
  
)

export default component.exports